
import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { toast } from "react-toastify";
import {partner_Admin } from "../../../Configuration/Partner_URL";
import { decryptData } from "../../../CommonMethhods/CommonMethods";
import { axiosSsoText } from "../../../CommonMethhods/axiosPartnerInterceptor";


function BarGraph() {
  const storeToken = localStorage.getItem("ssoToken");
    const [dates, setDates] = useState("");
    const [accCounts, setAccCounts] = useState("");
    const [barData, setBarData] = useState([]);

    const option = {
      credits: {
      enabled: false,
    },
        chart: {
            type: 'bar',
            type: 'column',
        },
        colors: ['#97E0F8'],
        title: {
          text: null,
        },
        xAxis: {
            categories: dates,
            title: {
              text: null,
            },
        },
        yAxis: {
          min: 0,
        // max: 7, 
        tickInterval: 1,
        // gridLineWidth: 0,
          title: {
            numeric : null,
            text: null,
            align: "high",
          },
        },
        labels: {
          enabled: true,
          overflow: "justify",
        },
        plotOptions: {
          series: {
            pointWidth: 40
        },
          bar: {
            dataLabels: {
              enabled: true,
            },
          },
        },
        tooltip: {
          pointFormat: `{series.name}: <b>{point.y:.2f}</b>`,
        },
        series: [{
            name: "Account series",
            data: accCounts
        }]

    }

    const getBarGraphData = async () => {
      try {
        const getValues = await axiosSsoText.get(
          partner_Admin.GetBardChart_URL,
        );
        const barVal = decryptData(getValues?.data);
        const decryptedBarVal = JSON.parse(barVal);
        if (decryptedBarVal?.status ===0) {
          setBarData(decryptedBarVal?.data)
        }
        else if(decryptedBarVal?.data?.status ===1){
        toast.error(decryptedBarVal?.data?.message);
        }
      } catch (error) {
        console.log(error);
      }
    };

      useEffect(()=>{
        getBarGraphData();
      }, []);



    const dataValue=()=>{
        const date = [];
        const accCount = [];
        barData.map((item) =>{
            date.push(item.activated_date.split("T")[0].split("-").reverse().join("-"))
            accCount.push(item.total_accounts)

        });
        setDates(date);
        setAccCounts(accCount);
    }


    useEffect(()=>{
        dataValue()
    }, [barData]);



    return (
        <>
          {/* <div className="card-title"> */}
          {/* <h2 className="small-title partner-title">
            Total Account Series
            </h2> */}

            <HighchartsReact
                highcharts={Highcharts}
                options={option}
            />
          {/* </div> */}
        </>
    );
}

export default BarGraph;
